import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

import { ChartWrapper } from 'src/components';


const useStyles = makeStyles(theme => ({
  chartContainer: {
    height: '300px',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.common.gray400,
  },
  subtitle: {
    fontWeight: 500,
    textTransform: 'uppercase',
    color: theme.palette.common.gray600,
    lineHeight: 1,
  },
}));

const SitesRichnessChart = () => {
  const classes = useStyles();

  // Datos de riqueza por año
  const richnessData = [
    { year: 2020, richness: 800 },
    { year: 2021, richness: 850 },
    { year: 2022, richness: 1210 },
    { year: 2023, richness: 1350 },
    { year: 2024, richness: 1580 },
  ];

  const chartData = {
    labels: richnessData.map(item => item.year),
    datasets: [
      {
        label: 'Riqueza Total',
        data: richnessData.map(item => item.richness),
        borderColor: '#2E7D32',
        backgroundColor: '#2E7D32',
        borderWidth: 2,
        fill: false,
        tension: 0.3,
        pointBackgroundColor: '#2E7D32',
        pointBorderColor: '#2E7D32',
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: context => `Riqueza: ${context.parsed.y}`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Año',
          font: {
            size: 12,
          },
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Riqueza Total',
          font: {
            size: 12,
          },
        },
        beginAtZero: false,
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
    },
  };

  return (
    <Box>
      <Typography className={classes.subtitle} variant="body2" component="span">
        Evolución de la Riqueza de Especies
      </Typography>
      <Box p={2} className={classes.chartContainer}>
        <ChartWrapper
          type="line"
          data={chartData}
          options={chartOptions}
        />
      </Box>
    </Box>
  );
};


export { SitesRichnessChart };